export function shouldApplyCustomSubmitFollowUp(result) {
  return result?.handled !== true;
}

export function shouldMarkWizardSubmitted(result) {
  if (result?.cancelled) return false;
  return result?.success === true;
}
